import React, { useState, useRef } from "react";
import { useMediaQuery } from "@react-hook/media-query";

// import { useInView } from "react-intersection-observer";

import Banner from "../banner/banner";
import Page from "../page/page";

import "./ContactPage.scss";
import classNames from "classnames";

const ContactPage = () => {
  const isPortrait = useMediaQuery("only screen and (orientation: portrait)");

  return (
    <>
      {/* <div className="backPage">{focusedPlayer.name}</div> */}
      <Page>
        <Banner
          texts={[`Contact & Informations`]}
          style={{ marginTop: "100px" }}
        />
        <div className="contactText">
          Vous êtes une entreprise ou un particulier ? <br />
          <br />
          <br />
          Nous ne sommes jamais très loin, contactez-nous à l'adresse suivante :{" "}
          <br />
          <br />
          <a
            className={classNames("mailLink", "showBookingButton")}
            href="mailto:contact@shotam.com"
            style={{ textAlign: "center", borderRadius: 5, padding: 5 }}
          >
            {" "}
            contact@shotam.app
          </a>
        </div>
      </Page>
    </>
  );
};

export default ContactPage;
